import Metadata from "~/components/metadata";
import prisma from "~/lib/prisma";
import Image from "next/image";
import HomeLayout from "~/components/layouts/home";
import { BASE_SELECT } from "~/cars/api/schemas";
import { formatCarToList } from "~/cars/api/utils";
import Link from "next/link";
import LocalAds from "~/components/local-ads";
import GoogleAd from "~/common/components/GoogleAd";
import { ADS } from "~/common/constants/googleAds";
import CarouselBanner from "~/components/CarouselBanner";
import { Dialog } from '@headlessui/react'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { FaTimes } from 'react-icons/fa'

import Card from "~/components/card";
//import ElementsSection from "~/components/element-section";
import ElementsSection from "~/components/element-section-new";

function StartPage({ className }) {

  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
      const getItem = async () => {
          const open = await  !sessionStorage.getItem('beenOpen')
          setIsOpen(open)
      }
      getItem()
  }, [])

  const modalStyles = {
      container: {
          display: 'flex',
          flexWrap: 'nowrap',
          alignContent: 'center',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          maxWidth: '1000px'
      },
      item: {
          dispaly: 'flex',
          // width: '700px',
          padding: '0px 10px'
      },
      image: {
          // width: '700px'
      }
  }

  const handleClose = () => {
      sessionStorage.setItem('beenOpen', true)
      setIsOpen(false)
  }

  return (

      <Dialog
          open={isOpen}
          onClose={handleClose}
          as="div"
          className={clsx(
              "fixed inset-0 z-10 flex items-center justify-center ",
              {
                  "bg-brand-primary bg-opacity-70": isOpen,
              }
          )}
      >
          <div
              className={clsx(
                  "flex flex-col rounded-lg relative bg-gray-50 text-black py-8 px-8 text-center",
                  className
              )}
          >
              <div className="absolute top-3 right-0">
                  <button
                      className="m-4 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm p-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={handleClose}
                  >
                      <FaTimes fontSize={12} />
                  </button>
              </div>
              <Dialog.Overlay />
              <Dialog.Title className="text-brand-dark text-3xl">
                        </Dialog.Title>


              <div style={modalStyles.container}>
                  <div style={modalStyles.item}><p>Desea entrar a </p><a href="https://www.inmueblessonora.com/"><img style={modalStyles.image} src="/images/modal_image_inmuebles.jpeg" alt="" /></a></div>
                  <div style={modalStyles.item}><p>O permanecer en</p><a onClick={handleClose}><img style={modalStyles.image} src="/images/modal_image_seminuevos.jpeg" alt="" /></a></div>
              </div>
          </div>
      </Dialog>
  )
}


export default function Home({
  lastAdded,
  lastRecomended,
  lastLotesAdded,
  lastAgenciasAdded,
}) {
  return (
    <div>
      <Metadata />
      <main className="flex w-full flex-col md:flex-row gap-4">
        <div className="w-12/12 md:w-10/12">
          <HomeLayout>
          {/*
            <a href="https://wa.me/+5216221001003?text=Quisiera%20mas%20informacion" >
              <CarouselBanner
                images={[
                  {
                    id: 1,
                    urlImage: "/images/banners/banner_vista_miramar.jpg",
                  },{
                    id: 1,
                    urlImage: "/images/banners/banner_vista_te_interesa.jpeg",
                  },
                ]}
              />
            </a>
            */}
            {/* --- SECCIÓN NUEVOS Y SEMINUEVOS (Añadir debajo del CarouselBanner) --- */}
<div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-3">
  
  {/* Bloque Izquierdo: Seminuevos (Ocupa 2 columnas en pantallas grandes) */}
  <div className="md:col-span-2 relative rounded-lg overflow-hidden bg-gradient-to-r from-neutral-900 to-neutral-800 text-white min-h-[300px] flex flex-col justify-between p-6 group">
    {/* Imagen de fondo / auto destacado */}
    <div className="absolute inset-0 z-0 opacity-70 group-hover:scale-105 transition-transform duration-500">
      <Image 
      src="/images/seccion_seminuevos.jpg"  // Cambia por tu ruta o usa una por defecto temporal
        layout="fill"
        objectFit="cover"
        alt="Seminuevos destacados"
      />
    </div>

    {/* Contenido superior */}
    <div className="relative z-10">
      <span className="bg-yellow-500 text-black font-bold text-xs uppercase px-3 py-1 rounded">
        Seminuevos
      </span>
      <h3 className="text-2xl font-extrabold mt-2 tracking-tight">
        Nissan, Volkswagen, Toyota y más...
      </h3>
    </div>

    {/* Botón inferior */}
    <div className="relative z-10 mt-4">
      <Link href="/autos?condition=seminuevos" legacyBehavior>
        <a className="inline-block bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-sm px-5 py-2.5 rounded transition-colors">
          Ver Inventario
        </a>
      </Link>
    </div>
  </div>

  {/* Bloque Derecho: Nuevos (Ocupa 1 columna) */}
  <div className="relative rounded-lg overflow-hidden bg-gradient-to-b from-neutral-900 to-neutral-800 text-white min-h-[300px] flex flex-col justify-between p-6 group">
    {/* Imagen de fondo / autos nuevos */}
    <div className="absolute inset-0 z-0 opacity-70 group-hover:scale-105 transition-transform duration-500">
      <Image 
        src="/images/seccion_nuevos.jpg" // Cambia por tu ruta de autos nuevos
        layout="fill"
        objectFit="cover"
        alt="Autos Nuevos"
      />
    </div>

    {/* Contenido superior */}
    <div className="relative z-10">
      <span className="bg-yellow-500 text-black font-bold text-xs uppercase px-3 py-1 rounded">
        Nuevos
      </span>
      <h3 className="text-xl font-extrabold mt-2 tracking-tight">
        Agencias y Modelos Recientes
      </h3>
    </div>

    {/* Botón inferior */}
    {/*
    <div className="relative z-10 mt-4">
      <Link href="/autos?condition=nuevos" legacyBehavior>
        <a className="inline-block bg-transparent border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold text-sm px-5 py-2 rounded transition-all text-center w-full md:w-auto">
          Explorar Modelos
        </a>
      </Link>
    </div>
     */}

      <div className="relative z-10 mt-4">
        <div className="inline-block bg-transparent border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold text-sm px-5 py-2 rounded transition-all text-center w-full md:w-auto">
          Próximamente
        </div>
    </div>
  </div>

</div>
{/* ========================================================================= */}
{/* SECCIÓN INTEGRADA: FINANCIAMIENTO, SEGUROS Y ARRENDAMIENTO                 */}
{/* ========================================================================= */}
<div className="w-full bg-zinc-950 rounded-xl border border-zinc-850 shadow-xl overflow-hidden mt-0 mb-0">
  <div className="grid grid-cols-1 lg:grid-cols-3 divide-y lg:divide-y-0 lg:divide-x divide-zinc-800">
    
    {/* COLUMNA 1: FINANCIAMIENTO AUTOMOTRIZ */}
    <div className="p-4 flex flex-col justify-between gap-3 text-white">
      <div className="flex items-start gap-3">
        <div className="bg-zinc-900 p-2 rounded-lg border border-zinc-800 flex-shrink-0 text-yellow-500">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div className="space-y-0.5">
          <h2 className="text-base font-black uppercase tracking-tight leading-tight">
            Financiamiento <span className="text-yellow-500">Automotriz</span>
          </h2>
          <p className="text-xs font-bold text-yellow-500">Tasa Base: 13.99% Anual</p>
          <p className="text-zinc-400 text-[11px] leading-normal mt-1">
            Estrena desde el <span className="text-white font-bold">29.99% de enganche</span>. Planes a tu medida con aprobación rápida.
          </p>
        </div>
      </div>
      <div className="pt-1">
        <Link href="/autos" legacyBehavior>
          <a 
          href="/documentos/financiamiento.pdf" 
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-full sm:w-auto bg-transparent hover:bg-yellow-500 hover:text-black text-yellow-500 font-bold border border-yellow-500 text-[10px] px-3 py-1 rounded transition-all text-center uppercase tracking-wider">
            Información y Requisitos
          </a>
        </Link>
      </div>
    </div>

    {/* COLUMNA 2: PLAZOS MÁXIMOS */}
    <div className="p-4 bg-zinc-900/30 flex flex-col justify-center text-white">
      <p className="text-[10px] font-bold uppercase tracking-wider text-zinc-400 text-center mb-2">
        Plazos Máximos Autorizados
      </p>
      <div className="overflow-x-auto w-full max-w-xs mx-auto">
        <table className="w-full text-[11px]">
          <tbody className="divide-y divide-zinc-800/40 text-zinc-300 font-medium">
            <tr>
              <td className="py-1 font-bold text-white">Modelos 2024 - 2027</td>
              <td className="py-1 text-right text-yellow-500 font-bold">96 a 120 meses</td>
            </tr>
            <tr>
              <td className="py-1 font-bold text-white">Modelos 2021 - 2023</td>
              <td className="py-1 text-right text-yellow-500 font-bold">60 a 84 meses</td>
            </tr>
            <tr>
              <td className="py-1 font-bold text-white">Modelos 2019 - 2020</td>
              <td className="py-1 text-right text-yellow-500 font-bold">36 a 48 meses</td>
            </tr>
            <tr>
              <td className="py-1 font-bold text-white">Modelos 2017 - 2018</td>
              <td className="py-1 text-right text-yellow-500 font-bold">12 a 24 meses</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

 {/* COLUMNA 3: SEGUROS Y ARRENDAMIENTO INTERNOS (AJUSTADA) */}
    <div className="p-3 flex flex-col justify-center gap-3 bg-zinc-900/40 h-full">
      
      {/* SEGUROS AUTOMOTRICES (VERSION BLANCA RESALTADA) */}
      <div className="flex items-center justify-between bg-white p-2.5 rounded-lg border border-gray-200 shadow-sm">
        <div className="flex items-center gap-2.5">
          <div className="bg-amber-400 p-2 rounded-md text-black flex-shrink-0 shadow-sm">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
            </svg>
          </div>
          <div>
            <h3 className="text-xs font-black uppercase text-zinc-950 leading-none">Seguros Automotrices</h3>
            <p className="text-[10px] text-zinc-600 font-medium mt-0.5 leading-tight">Cobertura completa, daños y RC.</p>
          </div>
        </div>
        <a 
          href="https://wa.me/+526221001003?text=Hola,%20solicito%20información%20sobre%20los%20Seguros%20Automotrices"
          target="_blank"
          rel="noreferrer"
          className="bg-zinc-900 hover:bg-black text-white hover:text-yellow-500 text-[9px] font-bold px-2.5 py-1.5 rounded transition-colors uppercase tracking-wider"
        >
          Cotizar
        </a>
      </div>

      {/* ARRENDAMIENTO PURO */}
      <div className="flex items-center justify-between bg-zinc-950 p-2.5 rounded-lg border border-zinc-800/85">
        <div className="flex items-center gap-2.5">
          <div className="bg-yellow-500 p-2 rounded-md text-black flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
          </div>
          <div>
            <h3 className="text-xs font-black uppercase text-white leading-none">Arrendamiento Puro</h3>
            <p className="text-[10px] text-zinc-400 mt-0.5 leading-tight">100% deducible para empresas y PFA.</p>
          </div>
        </div>
       {/* 🟢 BOTÓN MODIFICADO PARA EL PDF 🟢 */}
        <a 
          href="/documentos/arrendamiento.pdf" 
          target="_blank"
          rel="noopener noreferrer"
          className="bg-yellow-500 hover:bg-yellow-400 text-black text-[9px] font-bold px-2.5 py-1.5 rounded transition-colors uppercase tracking-wider"
        >
          Info
        </a>
      </div>

    </div>

  </div>
</div>



            <ElementsSection
              title="Autos Recomendados"
              more={{
                text: "Ver todos los autos recomendados",
                url: `/autos/recomendados`,
              }}
            >
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {lastRecomended.map((car) => {
                  const metas = [
                    /*
                    {
                      value: car.type,
                      link: `/autos/?type=${car.type}`,
                      borderless: false,
                      key: "type",
                    },
                    */
                    {
                      value: car.brand,
                      link: `/autos/?brand=${car.brand}`,
                      borderless: false,
                      key: "brand",
                    },
                    {
                      value: car.year,
                      link: `/autos/?year=${car.year}`,
                      borderless: false,
                      key: "year",
                    },
                    {
                      value: car.transmission,
                      link: `/autos/?transmission=${car.transmission}`,
                      borderless: false,
                      key: "transmission",
                    },

                    {
                      value: car.city,
                      link: `/autos/?city=${car.city}`,
                      borderless: false,
                      key: "city",
                    },

                    {
                      value: car.state,
                      link: `/autos/?state=${car.state}`,
                      borderless: false,
                      key: "state",
                    },
                  ];
                  return (
                    <Card
                      key={car.id}
                      car={car.title}
                      id={car.id}
                      slug={car.slug}
                      cover={
                        car.cover ||
                        "https://seminuevossonora.mx/inicio/autos/1645116654/1645116654_FIGO-3.jpg"
                      }
                      price={car.price}
                      metas={metas}
                      isRecomended={car.isPremium}
                    />
                  );
                })}
              </div>
            </ElementsSection>
            
      {/*
          <a>
              <CarouselBanner
                images={[
                  {
                    id: 1,
                    urlImage: "/images/banners/banner_intermedio.jpg",
                  },
                ]}
              />
            </a>
            */}

              <GoogleAd adSlot={ADS.PRADA} />

            <ElementsSection
              title="Autos Recientes"
              more={{
                text: "Ver todos los autos",
                url: `/autos`,
              }}
            >
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {lastAdded.map((car) => {
                  const metas = [
                  /*
                    {
                      value: car.type,
                      link: `/autos/?type=${car.type}`,
                      borderless: false,
                      key: "type",
                    },
                    */
                    {
                      value: car.brand,
                      link: `/autos/?brand=${car.brand}`,
                      borderless: false,
                      key: "brand",
                    },
                    {
                      value: car.year,
                      link: `/autos/?year=${car.year}`,
                      borderless: false,
                      key: "year",
                    },
                    {
                      value: car.transmission,
                      link: `/autos/?transmission=${car.transmission}`,
                      borderless: false,
                      key: "transmission",
                    },

                    {
                      value: car.city,
                      link: `/autos/?city=${car.city}`,
                      borderless: false,
                      key: "city",
                    },

                    {
                      value: car.state,
                      link: `/autos/?state=${car.state}`,
                      borderless: false,
                      key: "state",
                    },
                  ];
                  return (
                    <Card
                      id={car.id}
                      car={car.title}
                      slug={car.slug}
                      cover={
                        car.cover ||
                        "https://seminuevossonora.mx/inicio/autos/1645116654/1645116654_FIGO-3.jpg"
                      }
                      price={car.price}
                      metas={metas}
                      isRecomended={car.isPremium}
                      key={car.id}
                    />
                  );
                })}
              </div>
            </ElementsSection>

            <ElementsSection
              title="Lotes"
              more={{ text: "+ lotes", url: `/negocios?category=Lote` }}
            >
              <div className="grid gap-6 grid-cols-2 lg:grid-cols-4 text-center">
                {lastLotesAdded.map((lote) => {
                  return (
                    <Link
                      href={`/negocios/${lote.slug}`}
                      className="cursor-pointer text-center"
                      key={lote.slug}
                    >
                      <a>
                        <Image
                          className="rounded-full border-2 border-white"
                          src={lote.avatar || "/images/icon_placeholder.png"}
                          alt={lote.business}
                          width={142}
                          height={142}
                        />
                      </a>
                    </Link>
                  );
                })}
              </div>
            </ElementsSection>

            <ElementsSection
              title="Agencias"
              more={{
                text: "+ agencias",
                url: `/negocios?category=Agencia Seminuevos`,
              }}
            >
              <div className="grid gap-6 grid-cols-2 lg:grid-cols-4 text-center">
                {lastAgenciasAdded.map((agencia) => {
                  return (
                    <Link
                      href={`/negocios/${agencia.slug}`}
                      className="cursor-pointer text-center"
                      key={agencia.slug}
                    >
                      <a>
                        <Image
                          className="rounded-full border-2 border-white"
                          src={agencia.avatar || "/images/icon_placeholder.png"}
                          alt={agencia.business}
                          width={128}
                          height={128}
                        />
                      </a>
                    </Link>
                  );
                })}
              </div>
            </ElementsSection>
              <GoogleAd adSlot={ADS.HORIZONTAL_AD} />
             {/* <StartPage /> */}
          </HomeLayout>
        </div>
        <div className="w-12/12 md:w-2/12">
          <LocalAds />
            <GoogleAd adSlot={ADS.VERTICAL_AD_1} />
            <GoogleAd adSlot={ADS.VERTICAL_AD_2} />
        </div>
      </main>
    </div>
  );
}

export async function getServerSideProps() {
  const lastCarsAded = await prisma.car.findMany({
    where: {
      status: 3, //Publicados
    },
    take: 3,
    select: BASE_SELECT,
    orderBy: {
      // createdAt: "desc",
      publishedAt: "desc",
    },
  });
  const lastRecomendedCarsAdded = await prisma.car.findMany({
    where: {
      status: 3, //Publicado
      AND: {
        planId: 1,
      },
    },
    take: 3,
    select: BASE_SELECT,
    orderBy: {
      publishedAt: "desc",
    },
  });

  const lastLotesAdded = await prisma.business.findMany({
    where: {
      status: 1, // Activo
      line: 1, //Lote
      id: {
        not: 91, // Anonimo?
      },
    },
    take: 8,
    select: {
      slug: true,
      avatar: true,
      business: true,
    },
    orderBy: {
      createdAt: "desc",
    },
  });

  const lastAgenciasAdded = await prisma.business.findMany({
    where: {
      status: 1, // Activo
      line: 2, //Lote
    },
    take: 8,
    select: {
      slug: true,
      avatar: true,
      business: true,
    },
    orderBy: {
      createdAt: "desc",
    },
  });

  return {
    props: {
      lastRecomended: lastRecomendedCarsAdded.map(formatCarToList),
      lastAdded: lastCarsAded.map(formatCarToList),
      lastLotesAdded: lastLotesAdded,
      lastAgenciasAdded,
    },
  };
}
